export const NavMetaBase = (root) => {

    if (!root) {
        console.warn('No base meta navigation found');
        return undefined;
    }
};
